import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductRoutingModule } from './product-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ProductRoutingModule
  ]
})
export class ProductModule { }

export class MGetAllShopAllModuleDataResponse {
  statusCode!: number
  message!: string
  totalRecords!: number
  data!: MGetAllShopAllModuleDataResponseData
  token!: string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MGetAllShopAllModuleDataResponseData {
  categoryDetail!: MCategoryModal
  subCategoryList!: [MSubCategoryModal]
  skinTypeList!: [MSkinTypeModal]
  skinConcernList!: [MSkinConcernModal]
  categoryDetails: any;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MCategoryModal {
  id!: number
  name!: string
  description!: string
  category_code!: string
  thumbnail_img!: string
  is_active!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  is_blog!: boolean
  type!: number
  skin_type_title!: string
  skin_concern_title!: string
  gender!: number
  color!:any
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
export class MSubCategoryModal {
  id!: number
  category_id!: number
  name!: string
  description!: string
  sub_category_code!: string
  thumbnail_img!: string
  is_active!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  imageList!: [MImageListModal]
  category_name!: string
  skip!: number
  take!: number
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}


export class MSkinConcernModal {
  id!: number
  category_id!: number
  name!: string
  is_active!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  category!: string
  imageList: any
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MSkinTypeModal {
  id!: number
  category_id!: number
  name!: string
  is_active!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  category!: string
  imageList: any
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}


export class MGetProductRequest {
  categoryIds: any
  sub_category_id!: string
  skin_type!: string
  skin_concerns!: string
  ingredients!: string
  brand!: any
  relevence: any
  priceHighToLow: any
  skip: number = 0
  take: number = 20
  gender: any
  tags: any
  product_id: any
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MGetProductResponse {
  statusCode!: number
  message!: string
  totalRecords!: number
  data!: [MProductModal]
  token!: string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MGetBrandResponse {
  statusCode!: number
  message!: string
  totalRecords!: number
  data:any = [MBrandListModal]
  token!: string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MGetBrandByInitialsRequest {
  name!: string
  isInitials: any = false
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MProductModal {
  id!: number
  category_id!: number
  category!: MCategoryModal
  sub_category_id!: number
  subCategory!: string
  warehouse_id!: number
  warehouse!: string
  brand_id!: number
  brand!: MBrandListModal
  name!: string
  description!: string
  product_code!: string
  hsn!: string
  list_price!: number
  your_price!: number
  stock!: number
  minimum_qty!: number
  order_amount!: number
  handling_fee!: number
  sku!: string
  gender!: any
  genderString!: string
  size!: string
  alert_threshold!: number
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  is_suppliment!: boolean
  product_sale_type!: string
  skin_concerns!: any
  skin_type!: any
  free_from!: any
  why!: string
  who!: string
  benifits!: string
  expiry_date!: string
  country_of_origin!: string
  key_ingridents!: string
  key_ingredients_1!: string
  when_to_use_it!: string
  how_to_use_it!: string
  video_url!: string
  is_active!: boolean
  is_deleted!: boolean
  imageList: any = [MImageListModal]
  discountList!: [MDiscountListModal]
  skinTypes!: [MSkinTypeModal]
  skinConcerns!: [MSkinConcernModal]
  freeFroms!: [MFreeFromModal]
  extras!: [MExtraProduct]
  like: any
  cartQty!: number;
  color!: any;
  color_name!: any;
  taxes: any;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
export class MExtraProduct {
  id!: number
  sku!: string
  size!: string
  list_price!: number
  your_price!: number
  order_amount!: number
  discountList!: any;
  color_list: any;
  color_name: any;
  color: any;
  name: any;
  description: any;
  benifits: any;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MImageListModal {
  id!: number
  type!: string
  type_name!: string
  code!: string
  is_default!: boolean
  path!: string
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MBrandListModal {
  id!: number
  name!: string
  description!: string
  thumbnail_img!: string
  is_active!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  imageList!: [MImageListModal]
  code: any;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MDiscountListModal {
  id!: string
  brand_id!: number
  category_id!: number
  product_id!: number
  type!: string
  name!: string
  description!: string
  percentage!: number
  amount!: number
  discount_code!: string
  valid_from!: string
  valid_until!: string
  gender!: string
  image_url!: string
  max_amount!: number
  is_all!: boolean
  group_id!: string
  is_active!: boolean
  is_deleted!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  imageList!: [MImageListModal]
  brandList!: [MBrandListModal]
  categoryList!: [MCategoryModal]
  productList!: [MProductModal]
  brandCount!: number
  brand_id_Array!: string
  categoryCount!: number
  category_id_Array!: string
  productCount!: number
  product_id_Array!: string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MFreeFromModal {
  id!: number
  name!: string
  is_active!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



